import { createFileRoute, redirect } from "@tanstack/react-router";
import { PlantMaterialsSearchColumn } from "generated/graphql";
import { z } from "zod";

export const Route = createFileRoute("/_layout/sites/$siteSlug/map")({
  validateSearch: (search) =>
    z
      .object({
        searchValue: z.coerce.string().optional(),
        searchField: z
          .nativeEnum(PlantMaterialsSearchColumn)
          .optional()
          .catch(PlantMaterialsSearchColumn.ScientificName),
        latLng: z
          .object({ lat: z.number(), lng: z.number() })
          .optional()
          .catch(undefined),
        zoom: z.number().optional().catch(undefined),
      })
      .parse(search),
  loader: (opts) => {
    throw redirect({ ...opts, to: "/site/$siteSlug/map" });
  },
});
